import { motion } from "framer-motion";
import { EVENTS_MEDIA, useLang } from "@/i18n";

export default function EventsActivities() {
  const { t } = useLang();
  const e = t.events;

  return (
    <section id="eventos" className="px-5 py-24 sm:px-8 sm:py-32">
      <div className="mx-auto max-w-7xl">
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          className="mb-4 font-mono text-xs font-bold uppercase tracking-[0.3em] text-accent"
        >
          {e.label}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="font-display text-3xl font-extrabold uppercase tracking-tight sm:text-5xl"
        >
          {e.title}
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mt-4 max-w-xl text-sm text-zinc-400 sm:text-base"
        >
          {e.subtitle}
        </motion.p>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {e.items.map((item, i) => (
            <motion.article
              key={item.key}
              data-testid={`event-card-${item.key.replace(/_/g, "-")}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.55, delay: (i % 4) * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="group relative overflow-hidden rounded-2xl border border-white/10 bg-card transition-all duration-300 hover:border-accent/60 hover:shadow-[0_0_35px_rgba(255,0,122,0.18)]"
            >
              <div className="relative h-48 overflow-hidden">
                <img src={EVENTS_MEDIA[item.key]} alt={`${item.t} · K-HOUSE`} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-[linear-gradient(0deg,rgba(8,8,10,0.7)_0%,transparent_50%)]" />
              </div>
              <div className="p-5">
                <h3 className="font-display text-lg font-extrabold uppercase tracking-tight transition-colors duration-300 group-hover:text-accent">{item.t}</h3>
                <p className="mt-2 text-sm leading-relaxed text-zinc-400">{item.d}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}